// extracted by mini-css-extract-plugin
export default {"container":"NavFooterComponent_container__OwGs8","navLinks":"NavFooterComponent_navLinks__ORNTK"};